import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_99ch5ye698: FaireBrandEntity = {
  token: "b_99ch5ye698",
  type: "brand",
  name: "WJW",
  avatarUrl:
    "https://cdn.faire.com/fastly/74542e236b8ce9c765247b2f79164794e0630c8a7e942c646df0687f70696760.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/ad2801087cfef55d21778a7f95387feb0d93481c29b17f9618bf8141dae2851b.png",
  logoUrl:
    "https://cdn.faire.com/fastly/74542e236b8ce9c765247b2f79164794e0630c8a7e942c646df0687f70696760.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/ad2801087cfef55d21778a7f95387feb0d93481c29b17f9618bf8141dae2851b.png",
  location: "Destin, FL, USA",
  minimumOrderDollars: 50,
  rating: 4.9,
  reviewCount: 474,
  isTopShop: true,
  isInsider: true,
  description:
    "Wholesale Jewelry Website (WJW) is a USA owned and operated jewelry wholesaler. Located in Destin, FL, we offer a massive selection of over 10,000 different styles, colors, and sizes of rings, necklaces, bracelets, pendants, and more. Many of our pieces are made of durable, tarnish resistant stainless steel along with tungsten, leather, and sterling silver! We help provide everything your business needs to succeed, whether it be educational videos, starter kits and tools to stamp and personalize your customers' jewelry, or even just a friendly person to help you pick out the pieces that are best for your business.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:03.547Z",
    importedBy: "entity-db-cli",
  },
};
